// extracted by mini-css-extract-plugin
module.exports = {"divider":"CharacterBuilder_divider_1zjal","page":"CharacterBuilder_page_1Wn2Y"};